import { createElementBlock as t, openBlock as o, createElementVNode as r } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
};
function n(a, e) {
  return o(), t("svg", l, [...e[0] || (e[0] = [
    r("path", {
      fill: "currentColor",
      d: "m13.293 25.708-9-9a1 1 0 0 1 0-1.415l9-9a1 1 0 1 1 1.415 1.415L7.414 15h19.587a1 1 0 0 1 0 2H7.413l7.294 7.293a1 1 0 0 1-1.415 1.415"
    }, null, -1)
  ])]);
}
const s = { render: n };
export {
  s as default,
  n as render
};
